import { classNames } from '@repo/ui/src/utils/classNames';
import React, { ReactNode } from 'react';

const defaultAlignmentClasses = {
  right: 'left-unset -right-2 translate-x-0 after:right-[.5em]',
  center: 'left-1/2 -translate-x-1/2 right-unset after:left-1/2 after:-translate-x-1/2',
  left: '-left-2 right-unset translate-x-0 after:left-[.5em]',
};
const smAlignmentClasses = {
  right: 'sm:left-unset sm:-right-2 sm:translate-x-0 sm:after:right-[.5em]',
  center:
    'sm:left-1/2 sm:-translate-x-1/2 sm:right-unset sm:after:left-1/2 sm:after:-translate-x-1/2',
  left: 'sm:-left-2 sm:right-unset sm:translate-x-0 sm:after:left-[.5em]',
};
const mdAlignmentClasses = {
  right: 'md:left-unset md:-right-2 md:translate-x-0 md:after:right-[.5em]',
  center:
    'md:left-1/2 md:-translate-x-1/2 md:right-unset md:after:left-1/2 md:after:-translate-x-1/2',
  left: 'md:-left-2 md:right-unset md:translate-x-0 md:after:left-[.5em]',
};

export type Alignment = 'right' | 'center' | 'left';
// if more screen sizes are added to this in the future the appropriate classes need to be
// added in /style.css. This is outside tailwind so the prefixes have to be manually setup.
export type ScreenSize = 'default' | 'sm' | 'md';
export type ResponseAlignment = Partial<Record<ScreenSize, Alignment>>;
interface TooltipProps {
  visible: boolean;
  children: ReactNode;
  className?: string;
  alignment?: ResponseAlignment;
  below?: boolean;
}

const Tooltip = ({
  children,
  className,
  visible,
  below = false,
  alignment = {
    default: 'right',
    sm: 'left',
    md: 'center',
  },
}: TooltipProps) => {
  return (
    <span
      className={classNames(
        className,
        `absolute block max-w-[300px] w-max rounded lg:w-max transform transition-opacity duration-200 shadow z-10
        after:content-[''] after:absolute after:w-0 after:h-0 after:border-[.5em] after:border-transparent`,
        visible ? 'opacity-100' : 'opacity-0 pointer-events-none',
        defaultAlignmentClasses[alignment.default ?? 'left'],
        smAlignmentClasses[alignment.sm ?? 'center'],
        mdAlignmentClasses[alignment.md ?? 'center'],
        below ? 'top-full mt-2 after:top-[-1em]' : 'bottom-full mb-2 after:top-full',
      )}
    >
      <span
        className={classNames(
          className,
          `block relative text-xs lg:text-sm py-1 px-4 lg:px-4 text-center rounded-md`,
        )}
      >
        {children}
      </span>
    </span>
  );
};
export default Tooltip;
